import { ReactElement, useState } from 'react';
import { TicketingSdkContext } from '@mapado/js-component';
import { SeatingPlanPurchase, TicketingSdkInstance } from '@mapado/seating';
import TicketingSdk from '@mapado/ticketing-js-sdk';
import ContingentSelector from '../ContingentSelector';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import { getCart } from '../entityFactory';
import useQueryNumberParam from '../useQueryNumberParam';

type Props = {
  sdk: TicketingSdk;
};

export default function DemoSeatingPlanPurchase({ sdk }: Props): ReactElement {
  const eventDateId = useQueryNumberParam('eventDateId', 352518);
  const [selectedStockContingentId, setSelectedStockContingentId] = useState<
    null | string
  >(null);

  return (
    <>
      <EventDatePagesHeader title="Achat sur plan" eventDateId={eventDateId} />

      <hr />

      <TicketingSdkContext.Provider
        value={TicketingSdkInstance.getDefaultSerializerSdk()}
      >
        <ContingentSelector
          eventDateId={eventDateId}
          sdk={sdk}
          value={selectedStockContingentId}
          onChange={setSelectedStockContingentId}
        />
      </TicketingSdkContext.Provider>

      <hr />

      <SeatingPlanPurchase
        key={eventDateId}
        eventDateId={eventDateId}
        // @ts-expect-error -- don't really care about the type here
        // eslint-disable-next-line no-console
        setTicketPriceQuantity={console.log}
        // eslint-disable-next-line no-console
        lockSeatsForEventDate={console.log}
        cart={getCart()}
        currentContingentId={selectedStockContingentId}
      />
    </>
  );
}
